<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >

        <!-- direct v-model with formulate?  not sure if it can handle array well... if needed, pass it through your own handler -->
        <!-- <PrimeChips
            ref="chipsComponent"
            v-model="context.model"
            :addOnBlur="addOnBlur"
            :allowDuplicate="allowDuplicate"
            :max="max"
            :separator="separator"
            :placeholder="localPlaceholder"
            @input="onInput"
            @blur="onBlur"
            @focus="onFocus"
            @add="onAdd"
            @remove="onRemove"
        ></PrimeChips> -->
        <!-- WTF??? this component doesn't have :disabled prop!  must disable things "manually" -->

        <b-form-tags
            ref="chipsComponent"
            :value="localValue"
            @input="onInput"
            tag-variant="light"
            size="lg"
            :placeholder="localPlaceholder"
            :disabled="localDisabled"
            :limit="max"
            :separator="separator"
            :duplicate-tag-text="allowDuplicate ? '' : 'Duplicate values'"
            invalid-tag-text="Invalid value"
            @blur="onBlur"
            @focus="onFocus"
        ></b-form-tags>
        <!-- many other props possible: required, tag-validator, input-type (text, email, tel, url, etc.) etc... 
        no @add / @remove events, but there is one that has valid/invalid/duplicate tags - 'tag-state'
        -->
        
    </div>
</template>

<script>
//import PrimeChips from 'primevue/chips';

// for capturing an ARRAY of values (likely strings, but you could make it work with other types if needed - maybe add a prop for it)

export default {
    name: 'FormulateChips',
    components: {
        //PrimeChips,
    },
    mixins: [],
    props: {
        context: {  // standard Formulate input context 
            type: Object,
            required: true
        },
        // maybe add prop/props for specifying the data type... string, number, email addresses, etc.
        // then based on that, you should validate each item - connect w/ formulate validation system to show invalid if any items are invalid
        addOnBlur: {
            type: Boolean,
            default: false,
        },
        allowDuplicate: {
            type: Boolean,
            default: false,  // true is default for PrimeChips - but we want false most/all of time
        },
        max: {
            type: Number,
            required: false,
        },
        separator: {  // ',' (comma) is the only supported value, if any -- this is IN ADDITION to enter key
            type: String,
            required: false,  
        },
        placeholder: {  // formulate might pass it in context instead... so need to check both places in a computed
            type: String,  // we have a default in computed below, depends on localDisabled
            required: false,
        },
    },
    data() {
        return {
            // IF we keep local copy of value, we need to update / stay in sync with context.model
            localValue: [],  // parent may pass us empty string if no value in the form -- we need to normalize it here because input component expects an ARRAY, throws errors
        }
    },
    computed: {
        localPlaceholder() {
            const defaultPlaceholder = this.localDisabled ? '' : 'Add...';
            return this.context.attributes?.placeholder ?? this.context.placeholder ?? this.placeholder ?? defaultPlaceholder;  // placeholder might show up in multiple places... by default it is always in context.placeholder, but might be boolean false, so we || to a default
        },
        localDisabled() {
            return this.context.attributes?.disabled ?? this.context.disabled ?? false;
        },
    },
    watch: {
        'context.model': {
            immediate: true,
            handler: function (newValue) {  // need this so we are reactive to stuff passed via prop
                this.handleContextModel(newValue);
            },
        },
    },
    mounted() {
        
    },
    methods: {
        handleContextModel(propValue) {
            // called in watcher on context.model
            // need this so we are reactive -- set localValue - BUT MAKE SURE ITS AN ARRAY
            // should we handle comma separated values and split them???  maybe later
            this.localValue = Array.isArray(propValue) ? propValue : [];
        },
        onInput(value) {  // payload is the new value
            // need to handle the v-model ourselves through here... because parent will pass us value of "" by default, which input component does not like
            // so in here, we need to set context.model AND update localValue
            this.localValue = value;  // for the v-model behavior
            this.context.model = [...value];  // to report up to parent -- copy?
        },
        onBlur(evt) {  // payload is the native browser event
            // formulate wants us to connect this to context.blurHandler
            console.log('onBlur', evt);
            this.context.blurHandler(evt);
        },
        onFocus(evt) {  // payload is the native browser event
            console.log('onFocus', evt);
        },
        onAdd({ originalEvent, value }) {
            // payload is object? with originalEvent (browser event) and value (added item value)
            console.log('onAdd - event, value', originalEvent, value);
        },
        onRemove({ originalEvent, value }) {
            // payload is object? with originalEvent (browser event) and value (removed item value)
            console.log('onRemove - event, value', originalEvent, value);
        },
    }
}
</script>

<style lang="scss">

// need to make sure the input inside the chips component (from PrimeVue) does not inherit styles from formulate inputs
// we'll style here, not scoped, but that's OK since it will only apply to this data type / custom formulate input anyways

.formulate-input-element[data-type=multi_value_chips] {
    // if you use the bootstrap-vue b-form-tags one
    // you may be setting border colors, etc. in flowform component, for consistency
    .b-form-tags.form-control-lg {
        // top-bottom padding is big on size=lg, so make it smaller, and make text bigger
        padding-top: 0.25rem 1rem;
        .b-form-tag {
            font-size: 90%;  // normally b-form-tag font-size: 75%;
            border: 1px solid var(--gray-300);  // a slight border to make it pop
        }
        input.b-form-tags-input::placeholder {
            font-size: 90%;
        }
    }
    // if you use the PrimeVue one 
    .p-component.p-chips {
        width: 100%;  // make it stretch horizontally like normal inputs
        .p-inputtext.p-chips-multiple-container {
            width: 100%;  // gotta do it with its child too
            .p-chips-input-token > input {
                border-color: transparent;
            }
        }
    }
}



</style>